//auth routes
export const accountLogin = "api/LoginToAccount";
export const userLogout = "api/userLogout/";
// end auth routes

//roles
export const addNewRole = "api/newRole";
export const LoadRoles = "api/roles/";
export const updateRole = "api/roleUpdate";
export const deleteRole = "api/roleDelete/";
//end roles

//end modules
export const newModules = "api/newModule";
export const loadModules = "api/modules";
export const deleteModule = "api/moduleDelete/";
//modules

//permissions
export const newPermissions = "api/newPermission";
export const loadPermissions = "api/permissions";
export const deletePermission = "api/permissionDelete/";
//end permissions

//users
export const newUsers = "api/newUser";
export const loadUsers = "api/users";
export const updateUsers = "api/userUpdate";
export const deleteUser = "api/userDelete/";
export const Userprofile = "api/profileDetails";
export const updateProfile = "api/profileUpdate";
export const updateProfileImg = "api/updateUserImage";
//end users

//user roles
export const userRoles = "api/userRoles/";
export const modulePermissions = "api/modulePermissions";
export const asignuserRoleModules = "api/asignRoleModules";
export const asignModulePermissions = "api/assignModulesPermissions";
//end userroles

//customers
export const newCustomers = "api/newCustomer";
export const loadCustomers = "api/customers";
export const updateCustomers = "api/customerUpdate";
//end customers

//importers
export const newImporters = "api/newImporter";
export const loadImporters = "api/importers";
export const updateImporter = "api/importerUpdate";
//end importers

//shippinglines
export const newShippinglines = "api/newShippingline";
export const loadShippinglines = "api/shippinglines";
export const updateShippingline = "api/shippinglineUpdate";
//end shippinglines

//transporters
export const newTransporters = "api/newTransporter";
export const loadTransporters = "api/transporters";
export const updateTransporter = "api/transporterUpdate";
//end transporters

//fileopening
export const newFiles = "api/newFile";
export const loadFileopening = "api/files";
export const updateFileOpening = "api/fileopeningUpdate";
export const loadFile = "api/file_no";
//end fileopening

//cargoentries
export const newCargo = "api/newCargo";
export const loadCargo = "api/cargoentries";
export const loadCarg = "api/fileopeningcargos";
export const updateCargo = "api/cargoUpdate";
//end cargo entries

//shipping departments
export const newShipping = "api/newShipping";
export const loadShippings = "api/shippings";
export const loadShipping = "api/shippingfiles";
export const updateShipping = "api/shippingUpdate";
//end shipping departments

//customreleases  departments
export const newCustomrelease = "api/newCustomrelease";
export const loadCustomreleases = "api/customreleases";
export const updateCustomrelease = "api/customreleaseUpdate";
//end customreleases departments

//tarrifs
export const newTarrif = "api/newTarrif";
export const loadTarrifs = "api/tarrifs";
export const updateTarrif = "api/tarrifUpdate";
//end tarrifs

//trucks
export const newTruck = "api/newTruck";
export const loadTrucks = "api/trucks";
export const updateTruck = "api/truckUpdate";
//end trucks

//bonds
export const newBond = "api/newBond";
export const loadBonds = "api/bonds";
export const loadCustombonds = "api/custombonds";
export const updateBond = "api/bondUpdate";
//end bonds

//requisitions
export const newRequisition = "api/newRequisition";
export const loadRequisitions = "api/requisitions";
export const updateRequisition = "api/requisitionUpdate";
export const loadTransporter = "api/transporter";
export const loadTransporttrucks = "api/transportertrucks";
//end requisitions

//bondtrackings
export const newBondtracking = "api/newBondtracking";
export const loadBondtrackings = "api/bondtrackings";
export const updateBondtracking = "api/bondtrackingUpdate";
//end bondtrackings

//trucktrackings
export const newTrucktracking = "api/newTrucktracking";
export const loadTrucktrackings = "api/trucktrackings";
export const updateTrucktracking = "api/trucktrackingUpdate";
//end trucktrackings

//interchanges
export const newInterchange = "api/newInterchange";
export const loadInterchange = "api/interchanges";
//end interchanges

//reports
export const loadFileopenedDate = "api/fileopeneddates";
export const loadDailyExpense = "api/dailyexpenses";
export const loadWeeklyExpense = "api/weeklyexpenses";
export const loadMonthlyExpense = "api/monthlyexpenses";
export const loadFullExpense = "api/fullexpenses";
export const loadFullWeeklyExpense = "api/fullweeklyexpenses";
export const loadFullMonthlyExpense = "api/fullmonthlyexpenses";
export const loadDailyUpdate = "api/dailyupdates";
export const loadCashAccount = "api/cashaccounts";
//end reports

//petty cash
export const newPettycash = "api/newCash";
export const loadPettycashes = "api/pettycashes";
//end petty cash

//dailtransactions
export const newTransaction = "api/newTransaction";
export const loadTransactions = "api/dailytransactions";
export const viewTransactions = "api/dailytransaction";
//end dailytransactions

//accounttypes
export const newAccount = "api/newAccount";
export const loadAccounttype = "api/accounttypes";
//end accounttypes

//pettyaccounts
export const newPaymentaccounts = "api/newPaymentaccount";
export const loadPettyaccounts = "api/pettyaccounts";
//end pettyaccounts

//invoices
export const newInvoice = "api/newInvoice";
export const loadInvoice = "api/invoices";
export const viewInvoices = "api/invoice";
//end invoices



// WEBPACK FOOTER //
// ./src/routes/routes.js